// extracted by mini-css-extract-plugin
export default {"container_radio":"CustomRadio_container_radio__7ct1G"};